/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Settings_Dirs_Delete_Dialog_Title_SingleInputs */

const es_settings_dirs_delete_dialog_title_single = /** @type {(inputs: Settings_Dirs_Delete_Dialog_Title_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Eliminar "${i?.name}"?`)
};

const en_settings_dirs_delete_dialog_title_single = /** @type {(inputs: Settings_Dirs_Delete_Dialog_Title_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete "${i?.name}"?`)
};

/**
* | output |
* | --- |
* | "Delete \"{name}\"?" |
*
* @param {Settings_Dirs_Delete_Dialog_Title_SingleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_delete_dialog_title_single = /** @type {((inputs: Settings_Dirs_Delete_Dialog_Title_SingleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Delete_Dialog_Title_SingleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_delete_dialog_title_single(inputs)
	return en_settings_dirs_delete_dialog_title_single(inputs)
});
export { settings_dirs_delete_dialog_title_single as "settings.dirs.delete_dialog.title_single" }